const initialKanbanState = [
  {
    id: 1,
    title: 'Backlog',
    cards: [],
  },
  {
    id: 2,
    title: 'In Progress',
    cards: [],
  },
  {
    id: 3,
    title: 'Pendings',
    cards: [],
  },
  {
    id: 4,
    title: 'Delivered',
    cards: [],
  },
  {
    id: 5,
    title: 'Finished',
    cards: [],
  },
  {
    id: 6,
    title: 'Archived',
    cards: [],
  },
];

export { initialKanbanState };
